import React, { useEffect, useState } from "react";
import router from '../../../router';

import axios from '../../../plugins/axios';
import Toast from "../../../plugins/useToast";
import { useTranslation } from 'react-i18next';

import LogoImage from "../../../assets/img/logo.svg";
import { ReactComponent as IconSetting } from "../../../assets/icons/ic-setting.svg";
import { ReactComponent as IconMenuAccount } from "../../../assets/icons/ic-menu-account.svg";
import { ReactComponent as IconMenuPmd } from "../../../assets/icons/ic-menu-pmd.svg";
import { ReactComponent as IconMenuWard } from "../../../assets/icons/ic-menu-ward.svg";
import { ReactComponent as IconMenuSettings } from "../../../assets/icons/ic-menu-settings.svg";
import { ReactComponent as IconArrowRight } from "../../../assets/icons/ic-arrow-right-nobg.svg";
import packageJson from '../../../../package.json';

const SideMenu = ({userInfo,selectMenu,handSelectMenu}) => {    
    const { t } = useTranslation();
    const [user, setUser] = useState(null);
    const [openMenus, setOpenMenus] = useState({
        account: true,
        pmd: false,
        ward: false,
        settings: false,
    });

    // ✅ 서브 메뉴 있을 시 열고/닫기
    const toggleMenu = (menuKey) => {
        setOpenMenus((prev) => ({
            ...prev,
            [menuKey]: !prev[menuKey],
        }));
    };

    // ✅ 메뉴 클릭 시 핸들러
    const handleMenuClick = (menuKey, menuName) => {
        if (menuKey === 'UserSettings') {
            handSelectMenu(menuName);
        }
        // PMD, Ward는 서브메뉴가 없으므로 바로 선택        
        else if (menuKey === 'pmd' || menuKey === 'ward') {
            handSelectMenu(menuName);
        } else {
            // Account, Settings는 서브메뉴 토글만
            toggleMenu(menuKey);
        }
    };

    // ✅ 서브 메뉴 클릭 시 핸들러
    const handleSubMenuClick = (menuName) => {
        handSelectMenu(menuName);
    };    

    // ✅ 로그아웃
    const handleLogout = async (flag) => {
        try {
            const res = await axios.delete('/auth/logout')
            if (res.code != '200') throw res
            localStorage.removeItem('loginId')
            localStorage.removeItem('accessToken')
            localStorage.removeItem('lang')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('AdmincmsUserId')
            router.navigate('/admin');
        } catch (err) {
            Toast({ isSuccess: false , msg : t('error.retryLater') });
        }
    }

    useEffect(() => {
        setUser(userInfo);
    }, [userInfo]);

    return (
        <div className="relative flex flex-col justify-between w-[320px] h-screen bg-[#0D0D0F] p-[20px]">
            <div>
                <div
                    className="w-[279px] h-[25px] mt-7"
                    style={{
                        backgroundImage: `url(${LogoImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                />
                <div className="flex justify-between items-center w-full mt-6 pt-[7px] pb-[24px] mb-8 border-b border-b-[#29292E]">
                    <p className="text-gray-300 text-center font-pretendard font-bold text-[14px] leading-110">
                        {user?.loginId || "User"}
                    </p>
                    <IconSetting className="w-[32px] h-[32px] p-[7px] cursor-pointer" onClick={() => handleMenuClick("UserSettings", "UserSettings")} />
                </div>
                <nav className="relative w-full">
                    <ul className="w-full">
                        <li className="mb-2">
                            <div
                                className="flex items-center cursor-pointer py-[8px]"
                                onClick={() => handleMenuClick("account", "Account Management")}
                            >
                                <IconMenuAccount className="w-[24px] h-[24px] mx-[8px]" />
                                <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                    {t('admin.Account.menuName')}
                                </p>
                            </div>
                            <div
                                className={`transition-all duration-300 ease-in-out ${
                                    openMenus.account
                                        ? "grid-rows-[1fr] opacity-100"
                                        : "grid-rows-[0fr] opacity-0"
                                } grid`}
                            >
                                <div className="overflow-hidden">
                                    <ul className="flex flex-col">
                                        <li
                                            className={`${
                                                (selectMenu === "Account" || selectMenu === "AccountAdd" || selectMenu === "AccountEdit")
                                                    ? "bg-[#323238] rounded-[8px]"
                                                    : ""
                                            } w-full flex justify-start items-center px-10 py-[8px] cursor-pointer`}
                                            onClick={() => handleSubMenuClick("Account")}
                                        >
                                            <IconArrowRight className="mr-3" />
                                            <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                                {t('admin.Account.subMenuName')}
                                            </p>
                                        </li>
                                        <li 
                                            className={`${
                                                selectMenu === "Department"
                                                    ? "bg-[#323238] rounded-[8px]"
                                                    : ""
                                            } w-full flex justify-start items-center px-10 py-[8px] cursor-pointer`}
                                            onClick={() => handleSubMenuClick("Department")}
                                        >
                                            <IconArrowRight className="mr-3" />
                                            <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                                {t('admin.department.menuName')}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li className="mb-2">
                            <div
                                className={`${
                                    selectMenu === "PmdMngt"
                                        ? "bg-[#323238] rounded-[8px]"
                                        : ""
                                } flex items-center cursor-pointer py-[8px]`}
                                onClick={() => handleMenuClick("pmd", "PmdMngt")}
                            >
                                <IconMenuPmd className="w-[24px] h-[24px] mx-[8px]" />
                                <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                    {t('admin.device.title')}
                                </p>
                            </div>
                        </li>
                        <li className="mb-2">
                            <div
                                className={`${
                                    selectMenu === "WardMngt"
                                        ? "bg-[#323238] rounded-[8px]"
                                        : ""
                                } flex items-center cursor-pointer py-[8px]`}
                                onClick={() => handleMenuClick("ward", "WardMngt")}
                            >
                                <IconMenuWard className="w-[24px] h-[24px] mx-[8px]" />
                                <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                    {t('admin.ward.title')}
                                </p>
                            </div>
                        </li>
                        <li className="mb-2">
                            <div
                                className="flex items-center cursor-pointer py-[8px]"
                                onClick={() => handleMenuClick("settings", "System Settings")}
                            >
                                <IconMenuSettings className="w-[24px] h-[24px] mx-[8px]" />
                                <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                    {t('admin.systemSettings.title')}
                                </p>
                            </div>
                            <div
                                className={`transition-all duration-300 ease-in-out ${
                                    openMenus.settings
                                        ? "grid-rows-[1fr] opacity-100"
                                        : "grid-rows-[0fr] opacity-0"
                                } grid`}
                            >
                                <div className="overflow-hidden">
                                    <ul className="flex flex-col">
                                        <li 
                                            className={`${
                                                selectMenu === "Preferences"
                                                    ? "bg-[#323238] rounded-[8px]"
                                                    : ""
                                            } w-full flex justify-start items-center px-10 py-[8px] cursor-pointer`}
                                            onClick={() => handleSubMenuClick("Preferences")}
                                        >
                                            <IconArrowRight className="mr-3" />
                                            <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                                {t('admin.Preferences.Title')}
                                            </p>
                                        </li>
                                        <li 
                                            className={`${
                                                selectMenu === "HL7"
                                                    ? "bg-[#323238] rounded-[8px]"
                                                    : ""
                                            } w-full flex justify-start items-center px-10 py-[8px] cursor-pointer`}
                                            onClick={() => handleSubMenuClick("HL7")}
                                        >
                                            <IconArrowRight className="mr-3" />
                                            <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                                {t('admin.HL7.title')}
                                            </p>
                                        </li>
                                        <li 
                                            className={`${
                                                selectMenu === "BarcodeLabel"
                                                    ? "bg-[#323238] rounded-[8px]"
                                                    : ""
                                            } w-full flex justify-start items-center px-10 py-[8px] cursor-pointer`}
                                            onClick={() => handleSubMenuClick("BarcodeLabel")}
                                        >
                                            <IconArrowRight className="mr-3" />
                                            <p className="text-white font-light text-[16px] font-pretendard leading-110">
                                                {t('admin.BarcodeLabel.menuName')}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
            
            <div className="flex items-center justify-between mb-[8px]">
                <p 
                    className="text-white text-left font-[Pretendard] text-[14px] font-medium leading-[1.1] underline decoration-solid decoration-auto underline-offset-auto cursor-pointer"
                    onClick={() => handleLogout()}
                >   
                    {t('admin.logout')}
                </p>
                <p className="text-white text-left font-[Pretendard] text-[14px] font-medium leading-[1.1]">version : {packageJson.version}</p>
            </div>
        </div>
    );
};

export default SideMenu;
